import { WorkspaceScope } from "@ibada/shared-types/common"

export enum MinisterStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum MinisterKind {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
}

export type MinisterMinistryTypeSummary = {
  id: string
  name: string
  status?: string | null
}

export type MinisterBranchSummary = {
  id: string
  name: string
  slug?: string | null
  status?: string | null
}

export type MinisterMemberSummary = {
  id: string
  workspaceId?: string | null
  branchId?: string | null
  firstName?: string | null
  lastName?: string | null
  avatarUrl?: string | null
}

export type MinisterUserSummary = {
  id: string
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  avatarUrl?: string | null
}

export interface Minister {
  id: string
  workspaceId: string
  branchId?: string | null
  ministryTypeId?: string | null
  kind: MinisterKind
  displayName: string
  title?: string | null
  avatarUrl?: string | null
  bio?: string | null
  phone?: string | null
  email?: string | null
  memberId?: string | null
  userId?: string | null
  status: MinisterStatus
  notes?: string | null
  ministryType?: MinisterMinistryTypeSummary | null
  branch?: MinisterBranchSummary | null
  member?: MinisterMemberSummary | null
  user?: MinisterUserSummary | null
  createdAt: string
  updatedAt: string
}

export interface CreateMinisterInput {
  kind: MinisterKind
  displayName: string
  title?: string | null
  bio?: string | null
  phone?: string | null
  email?: string | null
  notes?: string | null
  workspaceId?: string | null
  branchId?: string | null
  ministryTypeId?: string | null
  memberId?: string | null
  userId?: string | null
  status?: MinisterStatus
}

export interface UpdateMinisterInput {
  displayName?: string
  title?: string | null
  bio?: string | null
  phone?: string | null
  email?: string | null
  notes?: string | null
  ministryTypeId?: string | null
  memberId?: string | null
  userId?: string | null
  status?: MinisterStatus
}

export type MinistersListQuery = {
  workspaceId?: string
  branchId?: string
  scope?: WorkspaceScope
  /** Workspace-wide management listing: all ministers across every branch (internal + external). */
  allBranches?: boolean
  kind?: MinisterKind
  ministryTypeId?: string
  status?: MinisterStatus
  q?: string
  search?: string
  page?: number
  limit?: number
  sortBy?: "createdAt" | "updatedAt" | "displayName" | "status"
  sortOrder?: "asc" | "desc"
  filters?: string
}

export type MinistersListResponse = {
  items: Minister[]
  total: number
  page: number
  limit: number
}
